import { getMaintenance } from '@repo/api';
import { QUERY_REFETCH_FAST } from '@repo/constants';
import { Maintenance, MaintenanceType } from '@repo/types';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { queryKeys } from './query-keys';

export const useMaintenanceQuery = (
  type: MaintenanceType,
  options?: Partial<UseQueryOptions<Maintenance>>,
) => {
  const { data, isLoading } = useQuery({
    ...options,
    queryKey: queryKeys.maintenance.details(type),
    queryFn: () => getMaintenance(type),
    refetchInterval: QUERY_REFETCH_FAST,
  });

  return {
    maintenance: data,
    isLoadingMaintenance: isLoading,
  };
};
